var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoldEventActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.472 5.038a.54.54 0 0 1 .546.088l3.03 2.635a.455.455 0 0 1 .001.677l-3.03 2.635a.539.539 0 0 1-.547.09.466.466 0 0 1-.305-.428V9.34H2.473c-.372 0-.673-.277-.673-.62V7.48c0-.343.301-.62.673-.62h2.694V5.465c0-.186.12-.353.305-.427zm6.31-4.911a.539.539 0 0 1 .546-.09.466.466 0 0 1 .305.428V1.86h2.694c.372 0 .673.277.673.62v1.24c0 .343-.301.62-.673.62h-2.694v1.395c0 .186-.12.353-.305.427a.54.54 0 0 1-.546-.088l-3.03-2.635a.455.455 0 0 1-.001-.677zM.6 14.8h8.8a.6.6 0 0 1 0 1.2H.6a.6.6 0 0 1 0-1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldEventActive);
export default __webpack_public_path__ + "static/media/fold-event-active.b0f665d9a63a8b7ac9166b8bd6bd548e.svg";
export { ForwardRef as ReactComponent };